// @ts-strict-ignore
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { BadgesContainer as Container, RootStoreState } from 'mytours-read-common'
import { Helmet } from 'react-helmet'
import { ionHistory } from 'mobile_web/modules/navigation'
import { getProfileUrl } from 'mobile_web/modules/navigation/routes'
import strings from '../../../strings'
import Page from '../../common/components/Page'
import BadgeGroupBlock from './BadgeGroupBlock'
import '../style.less'
import AudioPlayerBarComponent from 'mobile_web/modules/audio/components/AudioPlayerBar'

const Badges: FC<Container.Props> = ({ appManifest }) => {
	const currentLanguage = useSelector((state: RootStoreState) => state.settings.selectedLanguage)

	const handleGoProfile = () => {
		ionHistory.replace(getProfileUrl())
	}

	return (
		<>
			<Helmet
				title={strings.badges}
				meta={[
					{ name: 'description', content: strings.badges },
					{ property: 'og:type', content: 'website' },
					{ property: 'og:title', content: strings.badges },
					{ property: 'og:description', content: strings.badges },
					{ property: 'og:url', content: window.location.href },
				]}
			/>
			<Page
				contentProps={{
					className: 'profile-content',
				}}
				headerProps={{
					title: strings.badges,
					hideBackButton: true,
					buttonTextShadow: false,
					showBackButton: true,
					backButtonLabel: strings.profile,
					className: 'badges-header',
					onBackButton: handleGoProfile,

					collectionItem: null,
					itemType: null,
					itemId: null,
					collection: null,
					screen: null,
					hideFavouriteButton: true
				}}
				footer={{
					component: <AudioPlayerBarComponent bottomOffset={-1} />,
				}}
				dataCy="page-badges"
			>
				{appManifest?.badge_groups
					?.sort((a, b) => a.position - b.position)
					?.map(group => <BadgeGroupBlock key={group?.id} group={group} currentLanguage={currentLanguage} />)}
			</Page>
		</>
	)
}

const BadgesComponent = Container.default(Badges)
export default BadgesComponent
